<small *ngIf="reissuedInPaymentId || reissuedForPaymentId"
  class="d-block">
  <yc-i18n
    [key]="reissuedInPaymentId ?
      'GLOBAL:textReissuedAsPaymentNumber' :
      'GLOBAL:textReissueOfPaymentNumber'"
    [context]="{
      paymentNumber: reissuedInPaymentId || reissuedForPaymentId
    }"
    [defaultValue]="reissuedInPaymentId ?
      'Reissued as __paymentNumber__' :
      'Reissue  of __paymentNumber__'">
  </yc-i18n>
</small>